/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown> }} Automation_Task_Created_EventInputs */

const en_automation_task_created_event = /** @type {(inputs: Automation_Task_Created_EventInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} created`)
};

const pt_br2_automation_task_created_event = /** @type {(inputs: Automation_Task_Created_EventInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Criação de ${i?.task}`)
};

/**
* | output |
* | --- |
* | "{task} created" |
*
* @param {Automation_Task_Created_EventInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_task_created_event = /** @type {((inputs: Automation_Task_Created_EventInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Task_Created_EventInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_task_created_event(inputs)
	return pt_br2_automation_task_created_event(inputs)
});